import { render } from "./developer-portal.vue?vue&type=template&id=2442d59d&scoped=true"
import script from "./developer-portal.vue?vue&type=script&lang=js"
export * from "./developer-portal.vue?vue&type=script&lang=js"

import "./developer-portal.vue?vue&type=style&index=0&id=2442d59d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2442d59d"]])

export default __exports__